import { getMagicpinDetails } from 'containers/PostPaidFlow/Home2/services';
import { getURLParameter, nativeHandler } from 'utils';
import { _init, jsBridge } from './nativeHandlerV2';

export const formPostRequest = (path, params, method = 'post') => {
	const form = document.createElement('form');
	form.method = method;
	form.action = path;
	const hiddenField = document.createElement('input');
	hiddenField.type = 'hidden';
	hiddenField.name = getURLParameter('client') === 'gyftr' ? 'token' : 'data';
	hiddenField.value = params;
	form.appendChild(hiddenField);
	const extParam = getURLParameter('next');
	if (extParam) {
		const hiddenField = document.createElement('input');
		hiddenField.type = 'hidden';
		hiddenField.name = 'next';
		hiddenField.value = extParam;
		form.appendChild(hiddenField);
	}

	document.body.appendChild(form);
	form.submit();
};

const closeOnBackWebView = () => {
	_init().then(() => {
		jsBridge.closeWebview();
	});
};
export const fetchServiceDetails = async (urlParameter, extraData = false) => {
	const entries = {
		magicpin: 'ONDC_MAGICPIN',
		gyftr: 'GYFTR',
	};

	const userEmail = localStorage.getItem('userEmail');
	if (userEmail) {
		localStorage.removeItem('userEmail');
	}
	const payload = {
		name: entries[urlParameter],
		userEmail: encodeURI(userEmail) || null,
	};
	const thirdParty = localStorage.getItem('third-party');
	if (thirdParty) {
		localStorage.removeItem('third-party');
		setTimeout(() => {
			closeOnBackWebView();
		}, 2000);

		return;
	}

	await getMagicpinDetails(payload)
		.then((data) => {
			if (!data.data) closeOnBackWebView();
			const token = data.data;
			const url = data.url;
			localStorage.setItem('third-party', true);
			setTimeout(() => {
				formPostRequest(url, token, 'post');
			}, 500);

			nativeHandler.removeLoader();
		})
		.catch(() => {
			closeOnBackWebView();
		});
};
